import request from "./request.js";
import Servers from "@config";

export default {
  //预约实施列表
  fetchAppointmentList: request.get(
    Servers.oss + "/mall/client/appointment-status"
  ),
  //新增预约
  applyAppointment: request.get(Servers.oss + "/mall/client/apply-appointment"),
  //取消预约
  cancelAppointment: request.get(
    Servers.oss + "/mall/client/cancel-appointment"
  ),
  //短信验证码
  fetchAppointmentSmsVertifyCode: request.get(
    Servers.oss + "/mall/client/send-appointment-code"
  ),
  //预约实施收集 状态
  fetchAppointmentStatus: request.get(
    Servers.oss + "/mall/client/impl-client-status"
  ),
  //预约实施收集表单
  fetchAppointmentClientInfo: request.get(
    Servers.oss + "/mall/client/impl-client-info"
  ),
  //产品分类树
  fetchAppointmentCategoryTree: request.get(
    Servers.oss + "/mall/client/category-tree"
  ),
  // 预约实施收集表单 保存
  fetchAppointmentSave: request.post(
    Servers.oss + "/mall/client/impl-client-save"
  ),
  // 判断是否沙盒客户
  fetchCheckSandboxClient: request.get(
    Servers.oss + "/mall/client/check-sandbox-client"
  ),
  // 是否开启预约取消限制
  fetchCheckCancelAppointment: request.get(
    Servers.oss + "/mall/client/check-cancel-appointment-limit"
  ),
};
